"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PatientEncounterv2 = exports.CellPatientMaker = exports.CellMaker = exports.DataStyles = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var info_cellv2_1 = require("../info-cell/info-cellv2");
var case_prop_accessor2_1 = require("../case-prop-accessor/case-prop-accessor2");
var encounter_data_transformers_1 = require("./encounter-data.transformers");
var ui_common_1 = require("@codametrix/ui-common");
var conditional_1 = require("../conditional/conditional");
var svg_icons_1 = require("../svgs/svg-icons");
var getCoderNotesLookupParams = ui_common_1.AmplifyCore.coderNotesUtils.getCoderNotesLookupParams;
exports.DataStyles = {
    s: 'col-3 col-lg-4 col-md-4',
    ms: 'col-4 col-md-6',
    m: 'col-8',
    l: 'col-12'
};
var CellMaker = function (propAccessor, rawCaseRun, fieldEditorInfo, capability, showProviderInfo, activeContext) {
    var dataTransformer = (0, encounter_data_transformers_1.DataTransformers)(propAccessor, rawCaseRun, activeContext);
    return function (def) {
        var _a;
        var cellClassName = exports.DataStyles[def.dataSizeHorizontalView];
        var value = def.transformer
            ? dataTransformer[def.transformer](def.property)
            : propAccessor(def.property, 'N/A');
        var additionalInfo = (_a = def === null || def === void 0 ? void 0 : def.additionalInfo) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, info) {
            var key = info === null || info === void 0 ? void 0 : info.label;
            var value = info.transformer
                ? dataTransformer[info.transformer](info.property)
                : propAccessor(info.property, 'N/A');
            // Ensure both key and value are strings
            acc[key] = value === null || value === void 0 ? void 0 : value.toString();
            return acc;
        }, {}); // Initialize an empty object with string key-value types
        if ((value == 'N/A' || value == undefined) && def.defaultHide) {
            return null;
        }
        var _handleUpdate = function (updates) {
            var _a, _b;
            var caserun_uid = rawCaseRun.caserun_uid, service_line = rawCaseRun.service_line;
            var _c = fieldEditorInfo.caseEdits[def.key], initialVal = _c.initialVal, mappedValues = _c.mappedValues;
            if (updates.hasOwnProperty('patient_type')) {
                var patientTypeValue_1 = updates['patient_type'];
                var mappedValues_1 = ((_a = fieldEditorInfo.caseEdits['patient_class']) === null || _a === void 0 ? void 0 : _a.mappedValues) || [];
                var value_1 = (_b = mappedValues_1.find(function (item) { return item.label === patientTypeValue_1; })) === null || _b === void 0 ? void 0 : _b.value;
                if (value_1 !== undefined) {
                    rawCaseRun['patient_class'] = value_1;
                    updates['patient_class'] = value_1;
                }
            }
            fieldEditorInfo.updateCase({
                caseRunUid: caserun_uid,
                serviceLine: service_line == 'Inpatient Professional Coding'
                    ? 'ipc'
                    : service_line,
                caseUpdates: updates,
                initialVal: initialVal,
                mappedValues: mappedValues
            });
        };
        return ((0, jsx_runtime_1.jsx)(info_cellv2_1.InfoCell, { className: cellClassName, cellKey: def.key, label: def.label, value: value, fieldType: def.fieldType, fieldEditorInfo: __assign(__assign({}, fieldEditorInfo), { updateCase: function (updates) { return _handleUpdate(updates); } }), capability: capability, showProviderInfo: showProviderInfo, hasLink: (def === null || def === void 0 ? void 0 : def.additionalInfo) ? def === null || def === void 0 ? void 0 : def.hasLink : false, additionalInfo: additionalInfo }, "".concat(def.key)));
    };
};
exports.CellMaker = CellMaker;
var CellPatientMaker = function (propAccessor, rawCaseRun) {
    var dataTransformer = (0, encounter_data_transformers_1.DataTransformers)(propAccessor, rawCaseRun);
    return function (def) {
        var value = def.transformer
            ? dataTransformer[def.transformer](def.property)
            : propAccessor(def.property, 'N/A');
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "patient-cell" }, { children: [value, def.addHr ? (0, jsx_runtime_1.jsx)("div", { className: "vertical-divider" }) : null] }), def.key));
    };
};
exports.CellPatientMaker = CellPatientMaker;
var PatientEncounterv2 = /** @class */ (function (_super) {
    __extends(PatientEncounterv2, _super);
    function PatientEncounterv2(props) {
        var _this = _super.call(this, props) || this;
        _this.handleToggleClick = _this.handleToggleClick.bind(_this);
        _this.handleCoderNotesClick = _this.handleCoderNotesClick.bind(_this);
        _this.handleCoderNotesKeyDown = _this.handleCoderNotesKeyDown.bind(_this);
        _this.state = {
            expandEncounter: true
        };
        return _this;
    }
    PatientEncounterv2.prototype.handleToggleClick = function (ev) {
        ev.preventDefault();
        var expandEncounter = this.state.expandEncounter;
        var openClaims = this.props.openClaims;
        if (expandEncounter) {
            openClaims = [];
        }
        else {
            openClaims = __spreadArray(__spreadArray([], __read(openClaims), false), [
                { fieldIdentifier: 'showToggle', fieldName: 'showToggle' }
            ], false);
        }
        this.setState({
            expandEncounter: !expandEncounter
        });
        this.props.handleExpansion(!expandEncounter);
    };
    PatientEncounterv2.prototype.expandEncounter = function (expandEncounter) {
        this.setState({
            expandEncounter: expandEncounter
        });
        this.props.handleExpansion(expandEncounter);
    };
    /**
     * Handles the click event on the "Coder Notes" section.
     * Prevents default behavior and triggers the coder notes info display.
     *
     * @param {React.MouseEvent<HTMLDivElement>} ev - The mouse event object.
     * @returns {void}
     */
    PatientEncounterv2.prototype.handleCoderNotesClick = function (ev) {
        var _a;
        var activeItem = this.props.activeItem;
        var lookupParams = getCoderNotesLookupParams(activeItem);
        ev.preventDefault();
        this.props.showCoderNotesInfo(__assign(__assign({}, lookupParams), { patientMRN: (_a = activeItem === null || activeItem === void 0 ? void 0 : activeItem.patient_identifier) === null || _a === void 0 ? void 0 : _a.number, serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line }));
    };
    /**
     * Handles the keydown event on the "Coder Notes" section.
     * Triggers the coder notes info display when the Enter key is pressed.
     *
     * @param {React.KeyboardEvent<HTMLDivElement>} ev - The keyboard event object.
     * @returns {void}
     */
    PatientEncounterv2.prototype.handleCoderNotesKeyDown = function (ev) {
        var _a;
        var activeItem = this.props.activeItem;
        var lookupParams = getCoderNotesLookupParams(activeItem);
        if (ev.key === 'Enter') {
            ev.preventDefault();
            this.props.showCoderNotesInfo(__assign(__assign({}, lookupParams), { patientMRN: (_a = activeItem === null || activeItem === void 0 ? void 0 : activeItem.patient_identifier) === null || _a === void 0 ? void 0 : _a.number, serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line }));
        }
    };
    PatientEncounterv2.prototype.render = function () {
        var _a, _b;
        var classnames = ['patient-encounterv2'];
        var expandEncounter = this.state.expandEncounter;
        var _c = this.props, activations = _c.activations, activeItem = _c.activeItem, propertyConfig = _c.propertyConfig, fieldEditorInfo = _c.fieldEditorInfo, capability = _c.capability, flagList = _c.flagList, coderNotesCapability = _c.coderNotesCapability, workItem = _c.workItem;
        var flagListSet = Array.from(new Set(flagList === null || flagList === void 0 ? void 0 : flagList.map(function (flag) { return flag === null || flag === void 0 ? void 0 : flag.flag; })));
        var propActivations = (_a = activations === null || activations === void 0 ? void 0 : activations.property) !== null && _a !== void 0 ? _a : {};
        var prop = (0, case_prop_accessor2_1.propAccessor2)(__assign(__assign({}, activeItem), workItem), activations.property);
        var cellMaker = (0, exports.CellMaker)(prop, activeItem, fieldEditorInfo, capability, this.props.showProviderInfo, this.props.activeContext);
        var cellPatientMaker = (0, exports.CellPatientMaker)(prop, activeItem);
        // all info less last item
        var patientConfig = propertyConfig.patient.slice(0, propertyConfig.patient.length - 1);
        // last item
        var patientLastItem = propertyConfig.patient.slice(-1);
        // add hr less the last one item
        patientConfig = patientConfig.map(function (patient, index) {
            return __assign(__assign({}, patient), { addHr: index + 1 !== patientConfig.length });
        });
        var midCells = propertyConfig.summary.map(cellMaker);
        var showComments = ui_common_1.conditionalUtils.capabilityValue((_b = coderNotesCapability === null || coderNotesCapability === void 0 ? void 0 : coderNotesCapability.on) !== null && _b !== void 0 ? _b : false);
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(classnames) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "patient-info-container", "data-testid": "patient-info-container" }, { children: [(0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [(flagListSet === null || flagListSet === void 0 ? void 0 : flagListSet.length) > 0] }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex-section ".concat(ui_common_1.caseUtils.getStatusReason(activeItem) ? 'zeroTopPadding' : '') }, { children: flagListSet.map(function (flag, index) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flag-item-box" }, { children: (0, jsx_runtime_1.jsx)("p", __assign({ className: "flag-item", title: flag }, { children: flag })) }), "flag-".concat(index))); }) })) })), propertyConfig.summary.length > 0 && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "info-block" }, { children: midCells })))] })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [showComments] }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ tabIndex: 0, onClick: this.handleCoderNotesClick, onKeyDown: this.handleCoderNotesKeyDown, className: "coder-comments-section" }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconClass: "coder-commentsv2", svgIconName: "BiomeComments", svgIconSize: "24" }) })) }))] })));
    };
    PatientEncounterv2.displayName = 'PatientEncounter';
    PatientEncounterv2.defaultProps = {
        openClaims: [],
        showLoading: false,
        activations: {},
        handleExpansion: function (expanded) { },
        showProviderInfo: function (providerInfo) { },
        propertyConfig: {
            patient: [],
            summary: [],
            expanded: []
        },
        flagList: [],
        workItem: {
            owner: '',
            assignee: '',
            aging_days: '',
            codable_days: ''
        }
    };
    return PatientEncounterv2;
}(react_1["default"].Component));
exports.PatientEncounterv2 = PatientEncounterv2;
//# sourceMappingURL=patient-encounterv2.js.map